import { createContext, useContext, useState, useCallback } from 'react';
import ScanQrUpdateStatusModal from '../components/shipment-qr-status/ScanQrUpdateStatusModal.js';

const ScanQrModalContext = createContext(null);

export const ScanQrModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openScanQrModal = useCallback(() => setIsOpen(true), []);
  const closeScanQrModal = useCallback(() => setIsOpen(false), []);

  return (
    <ScanQrModalContext.Provider value={{ openScanQrModal, closeScanQrModal, isOpen }}>
      {children}
      <ScanQrUpdateStatusModal isOpen={isOpen} onClose={closeScanQrModal} />
    </ScanQrModalContext.Provider>
  );
};

export const useScanQrModal = () => {
  const ctx = useContext(ScanQrModalContext);
  if (!ctx) {
    return {
      openScanQrModal: () => {},
      closeScanQrModal: () => {},
      isOpen: false,
    };
  }
  return ctx;
};
